<div class="db-website-install-option"
     *ngFor="let option of options"
     [ngClass]="{'active': option.mode === selectedMode}"
     (click)="modeSelected.emit(option.mode)">
  <input class="ds-radio" type="radio" [id]="option.mode" [value]="option.mode" [(ngModel)]="selectedMode">
  <label [for]="option.mode"></label>
  <p class="ds-card-radio-text" [innerHTML]="option.slug"></p>
</div>
